/* ---------------------------------------------------------------------------
 * MD Fashionwear — single-size box label
 *
 * When a recommended product has exactly one size available, md-cart-recs.js
 * renders a static box in place of the dropdown. It writes "Size: S", but the
 * dropdown next to it just reads "XS" — so the pair looked mismatched once the
 * static version was styled as a matching field.
 *
 * This trims the label so both boxes read the same way: the bare size.
 *
 * WHY A SEPARATE FILE
 * It is one line of behaviour in a 15KB module, and the theme API only writes
 * whole files. Re-uploading the whole builder to change a label risks a
 * transcription error in code that is now working; this does not.
 *
 * NO MUTATION OBSERVER. Writing textContent creates a text node, which is what
 * caused an earlier repaint loop that froze the tab. This polls an attribute
 * instead, and marks each box once handled so it is never touched twice.
 * ------------------------------------------------------------------------- */

(function () {
  'use strict';

  function trim() {
    var boxes = document.querySelectorAll('.md-rec__sizeline');

    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.getAttribute('data-md-trimmed') === '1') continue;

      var txt = (box.textContent || '').trim();
      if (!txt) continue;

      // "Size: S" -> "S". Anything without the prefix is left alone.
      var cleaned = txt.replace(/^size\s*:\s*/i, '');
      if (cleaned !== txt) box.textContent = cleaned;

      box.setAttribute('data-md-trimmed', '1');
    }
  }

  function boot() {
    trim();
    setInterval(trim, 700);

    var soon = function () { setTimeout(trim, 120); };
    document.documentElement.addEventListener('cart:refresh', soon);
    document.addEventListener('cart:change', soon);
    document.addEventListener('variant:add', soon);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.MDCartSizeLine = { trim: trim };
})();
